import {css} from '../styled-components';

export const smooth = (property = 'all', duration = '300ms', timingFn = 'ease-in-out') => css`
    transition: ${property} ${duration} ${timingFn};
`;
